module.exports = __webpack_public_path__ + "img/875b18003f385d44f9c5253ebfc5c048.png";